import { useContext } from 'react';
import { ProjectContext } from '../contexts/ProjectContext';

/** Read the active factory project from ProjectProvider. */
export function useProject() {
  const ctx = useContext(ProjectContext);
  if (!ctx) {
    throw new Error('useProject must be used within ProjectProvider');
  }
  return ctx;
}
